import React from 'react';
import { Outlet } from 'react-router-dom';
import GlobalSidebar from '../../sidebar/GlobalSidebar';



const GlobalLayout: React.FC = () => {
  return (
    <>
      <GlobalSidebar />
      <main className="flex-1 flex flex-col overflow-hidden h-full">
        <Outlet />
      </main>
    </>
  );
};

export default GlobalLayout;